export const inverseLerp = (a = 0, z = 1, value = 0.5) =>
  (value - a) / (z - a)
